import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const CLE_STOCKAGE = "ramba.cookieConsent";

/** Bandeau de consentement aux cookies — affiché une seule fois tant que
 * l'utilisateur n'a pas fait de choix (accepté ou refusé), mémorisé en local. */
export function CookieConsent() {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choix = window.localStorage.getItem(CLE_STOCKAGE);
    if (!choix) setVisible(true);
  }, []);

  const repondre = (valeur: "accepte" | "refuse") => {
    window.localStorage.setItem(CLE_STOCKAGE, valeur);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label={t("cookies.title")}
      className="fixed inset-x-0 bottom-0 z-50 border-t border-border bg-background/98 backdrop-blur shadow-elevated md:bottom-4 md:left-4 md:right-auto md:max-w-md md:rounded-lg md:border"
    >
      <div className="flex flex-col gap-3 p-4 sm:p-5">
        <div className="flex items-start gap-2.5">
          <Cookie className="mt-0.5 h-4 w-4 shrink-0 text-verified" />
          <p className="text-xs leading-relaxed text-foreground/90">
            {t("cookies.description")}{" "}
            <Link to="/privacy" className="underline hover:text-foreground">
              {t("cookies.learnMore")}
            </Link>
          </p>
        </div>
        <div className="flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={() => repondre("refuse")}
            className="rounded-md border border-border px-3 py-1.5 text-xs font-semibold text-foreground hover:bg-surface transition-colors"
          >
            {t("cookies.reject")}
          </button>
          <button
            type="button"
            onClick={() => repondre("accepte")}
            className="rounded-md bg-foreground px-3 py-1.5 text-xs font-semibold text-background hover:opacity-90 transition-opacity"
          >
            {t("cookies.accept")}
          </button>
        </div>
      </div>
    </div>
  );
}
